import { useParams, Link, Navigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { getPostBySlug } from '../data/blogPosts';
import BlogCover from '../components/BlogCover';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

export default function BlogPost() {
  const { slug } = useParams();
  const { colors } = useTheme();
  const post = getPostBySlug(slug);

  if (!post) return <Navigate to="/blog" replace />;

  const s = {
    section: { padding: '120px 5vw 80px', background: colors.bg, minHeight: '100vh' },
    container: { maxWidth: '760px', margin: '0 auto' },
    back: {
      fontSize: '0.8rem', color: colors.muted, textDecoration: 'none',
      marginBottom: '2rem', display: 'inline-block',
    },
    cover: { marginBottom: '2rem', overflow: 'hidden' },
    meta: {
      fontFamily: "'JetBrains Mono', monospace", fontSize: '0.72rem',
      color: colors.muted, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '1rem',
    },
    title: {
      fontFamily: "'Inter', sans-serif", fontWeight: 800,
      fontSize: 'clamp(2.2rem, 5vw, 3.5rem)',
      lineHeight: 1.05, letterSpacing: '1px', color: colors.text, marginBottom: '2rem',
    },
    paragraph: {
      fontSize: '1rem', lineHeight: 1.9, color: colors.textBody,
      marginBottom: '1.5rem', fontWeight: 300,
    },
  };

  return (
    <section style={s.section}>
      <div style={s.container}>
        <Link to="/blog" style={s.back}>← Back to all posts</Link>
        <div style={s.cover}>
          <BlogCover cover={post.cover} height="clamp(220px, 40vw, 400px)" sizes="(max-width: 800px) 100vw, 760px" eager />
        </div>
        <div style={s.meta}>{post.category} · {formatDate(post.date)}</div>
        <h1 style={s.title}>{post.title}</h1>
        {post.content.map((paragraph, i) => (
          <p key={i} style={s.paragraph}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
